export enum TerminalSummaryPath {
  number = "number"
}

export interface PathParams {
  [TerminalSummaryPath.number]: string;
}

